
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { AlarmTag } from '@/store/eventqueue/types';

import EventSearchModel from "@/types/eventSearch/EventSearchModel";
import vSelect from "vue-select";
import EventFilter from './EventFilter.vue';
import { namespace } from 'vuex-class';
import { groupsApi } from '@/services/api.groups.service';

const Setup = namespace("setup");

@Component({
    components: {
        "event-filter": EventFilter,
        "v-select": vSelect,
    }
})
export default class AlarmTagsFilter extends Vue {
    @Prop({ default: null, type: Object }) value: EventSearchModel;

    @Setup.State responseAlarmTypes!: AlarmTag[];

    @Setup.Action loadResponseAlarmTypes!: () => Promise<void>;

    private selectDeselectAll: boolean = false;

    private selectedAlarmTags: AlarmTag[] = [];

    private groupAncestors: number[] = [];

    /**
     * @summary Mounted hook
     * - fetches response alarm types.
     */
    private async mounted(): Promise<void> {
        await this.loadResponseAlarmTypes();
    }

    /**
     * @summary Computed property used to filter responseAlarmTypes to only retrieve the desired
     * ones for the current group and it's ancestors
     */
    private get getAlarmTagsForGroup(): AlarmTag[] {
        return this.responseAlarmTypes.filter(x => this.groupAncestors.includes(x.groupId));
    }

    /**
     * @summary Method to set and unset all  alarm tags
     */
    private selectDeselectAlarmTags() {
        this.selectDeselectAll = !this.selectDeselectAll;
        if (this.selectDeselectAll) {
            this.value.alarmTags = this.getAlarmTagsForGroup.map(x => x.responseAlarmTypeID);
            this.selectedAlarmTags = this.getAlarmTagsForGroup;
        } else {
            this.value.alarmTags = [];
            this.selectedAlarmTags = [];
        }
    }

    /**
     * @summary Watcher used to map the selected alarm tags to their id's
     * and set the eventSearchModel alarm tags
     */
    @Watch("selectedAlarmTags", { deep: true })
    private alarmTagChange(alarmTags: AlarmTag[]) {
        const ids = alarmTags.map(x => x.responseAlarmTypeID);
        this.value.alarmTags = ids;
    }

    /**
     * @summary watcher to identify when the group has changed, when it has changed.
     * get the group ids from current through ancestors to root group.
     */
    @Watch("value.groupID")
    private async groupChange(groupId: number, oldGroupId: number): Promise<void> {
        if (!groupId) return;
        if (groupId == oldGroupId) return;

        const data = await groupsApi.getGroupAncestorsIdsById(groupId);
        this.groupAncestors = data;

        if (!this.selectDeselectAll) {
            const containingIds = this.selectedAlarmTags.map(p => p.responseAlarmTypeID);
            this.selectedAlarmTags = this.getAlarmTagsForGroup.filter((x: AlarmTag) => containingIds.includes(x.responseAlarmTypeID));
        } else {
            this.selectedAlarmTags = this.getAlarmTagsForGroup;
        }
    }
}
